import React from 'react';
import {
	Container,
	IconContainer,
	ImageContainer,
	InfoContainer,
	SkeletonInfoContainer,
	Subtitle,
	Title,
} from './ContextInput.styles';
import ChecklistIcon from 'App/assets/img/checklist-icon-big.png';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { Skeleton } from '@welbe/web-design-system';

export const ContextInput = ({ loading, reference, isOption, isOpen }: any) => {
	return (
		<Container noHover={!loading}>
			{loading ? (
				<>
					<ImageContainer>
						<Skeleton borderRadius="4px" width="30px" />
					</ImageContainer>
					<SkeletonInfoContainer>
						<Skeleton borderRadius="4px" height="14px" width="100px" />
						<Skeleton borderRadius="4px" height="20px" width="170px" />
					</SkeletonInfoContainer>
					<IconContainer open={false}>
						<Skeleton borderRadius="4px" height="20px" width="20px" />
					</IconContainer>
				</>
			) : (
				<>
					<ImageContainer>
						{!isOption && <img width="30px" src={ChecklistIcon} />}
					</ImageContainer>
					<InfoContainer>
						<Title>{reference?.technicalName}</Title>
						<Subtitle>{reference?.name}</Subtitle>
					</InfoContainer>
					{!isOption &&
						(isOpen ? (
							<IconContainer open={false}>
								<FiChevronDown color="#5082C2" fontSize="20px" />
							</IconContainer>
						) : (
							<IconContainer open={false}>
								<FiChevronUp color="#5082C2" fontSize="20px" />
							</IconContainer>
						))}
				</>
			)}
		</Container>
	);
};
